import { FC } from 'react';

import { Eye } from 'lucide-react';
import useSWR from 'swr';

import Typography from '@mui/material/Typography';

import { PartnerSpotlightForm } from '../form';

import { SponsorCard } from './sponsorCard/SponsorCard';

import css from './PartnerSpotlightPreview.module.css';

import { casinoService } from 'v2/api/casinoService';
import { PromoPackTypeEnum } from 'v2/types/CasinoModel';

interface PartnerSpotlightPreviewProps {
  values: PartnerSpotlightForm;
}

export const PartnerSpotlightPreview: FC<PartnerSpotlightPreviewProps> = ({ values }) => {
  const { data: casinos } = useSWR('getCasinos', casinoService.getCasinos);

  const casino = casinos?.find((c) => c.id === values.partnerId);

  return (
    <div className={css.partnerSpotlightPreview}>
      <div className={css.partnerSpotlightPreviewHeader}>
        <Eye width={16} height={16} />
        <Typography variant="overline">Preview</Typography>
      </div>

      <div className={css.partnerSpotlightPreviewStage}>
        <SponsorCard
          status={values.status}
          backgroundImageId={values.backgroundImageId}
          isBackgroundOnly={values.isBackgroundOnly}
          hasNewBadge={values.hasNewBadge}
          bonusReceivedText={values.bonusReceivedText}
          extraOfferText={values.extraOfferText}
          promoCode={values.promoCode}
          isLotteryActive={values.lotteryEnabled}
          lottery={{
            imageId: values.lottery.imageId,
            description: values.lottery.description,
            promoTexts: [values.lottery.promo1, values.lottery.promo2].filter((s) => s.trim().length > 0),
            endDate: values.lottery.endDate,
          }}
          partnerData={{
            name: casino?.name ?? '',
            logoId: casino?.transparentLogoId ?? null,
            benefits: {
              promoPackType: casino?.benefits.promoPackType ?? PromoPackTypeEnum.STANDARD,
              freeSpinsCount: casino?.benefits.freeSpinsCount ?? null,
              depositPercentage: casino?.benefits.depositPercentage ?? null,
              customPromo: casino?.benefits.customPromo ?? null,
            },
          }}
        />
      </div>
    </div>
  );
};
